import React, { useState } from "react";
import Modal from "react-modal";
import { branch } from "recompose";
import { IconButton } from "theme/components/atoms/Button";
import SubscribeToInStockAlert from "theme/modules/SubscribeToInStockAlert";
import { H4 } from "theme/components/atoms/Typography/Heading";
import { FormattedMessage } from "react-intl";

const ModalAlertStock = ({ sku }) => {
  const [popin, setPopinState] = useState(true);
  return (
    <Modal
      isOpen={popin}
      onRequestClose={() => {
        setPopinState(true);
      }}
      overlayClassName="modal__overlay product-added__overlay"
      contentLabel="Product Stock Window"
      className="modal__content product-added modal-alert-stock"
    >
      <div className="product-added_background">
        <IconButton
          icon="cross"
          size="small"
          appearance="icon"
          title="close"
          onClick={() => {
            setPopinState(false);
          }}
        />
        <section className="product-added__wrapper">
          <div className="product-added__title">
            <H4>
              <FormattedMessage
                id="modules.ModalAlertStock.receiptAlert"
                defaultMessage="Out of stock size"
              />
            </H4>

            <p>
              <FormattedMessage
                id="modules.ModalAlertStock.description"
                defaultMessage="We'll send you a notification email when the item is available again"
              />
            </p>
          </div>

          <SubscribeToInStockAlert sku={sku} setPopinState={setPopinState} />
        </section>
      </div>
    </Modal>
  );
};

export default branch(
  (props) =>
    (props.stock.isInStock === false ||
      props.currentConfigIsInStock === false) &&
    Object.keys(props.selectedOptions).length > 0,
  (BaseComponent) => BaseComponent,
  () => () => null
)(ModalAlertStock);
